<template>
  <div class="login-wrapper">
    <div class="background">
      <div class="header">
        <img src="@/assets/img/logo.png" alt="" />
      </div>
      <div class="banner">
        <img src="@/assets/img/login-banner.png" alt="" />
      </div>
      <div class="body">
        <div class="short-description">
          网约房即网络预约居住房屋，是共享经济下的新业态，近年来增长迅猛，大多在商业区、人员密集的小区、公寓及写字楼内。
        </div>
        <div class="service-target">
          <span class="title">网约房平台三大服务主体</span>
          <div class="content">
            <div class="top">
              网约房智慧综合解决方案将治安管理与社区网格化管理进行深度融合，以推进智慧城市、智慧旅游等建设，针对网约房、民宿客栈等容纳流动人员场所利用信息化手段进行管控，在网约房管理上实现房源备案、实人实住、实数登记、实时上传、在线监管的全方位、智慧化、规范化管理，通过智能应用，给网约房经营者提供更多人性化、信息化服务，提升房东的经营效率，减少经营风险；租客便捷入住的同时，保障租客的入住安全。
            </div>
            <div class="bottom">
              <div class="item" v-for="(item, i) of list" :key="i">
                <div class="image">
                  <img :src="item.image" alt="" />
                  <div :style="{ background: item.color }">
                    {{ item.title }}
                  </div>
                </div>
                <div class="description">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-feature">
          <div class="title">主要功能介绍</div>
          <div class="content">
            <div class="item" v-for="(item, i) of featureList" :key="i">
              <div class="circle"></div>
              <div class="info">
                <div class="info-title">{{ item.title }}</div>
                <div class="info-detail">{{ item.detail }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        隐私政策|法律声明版权所有: Copyright ©2011-2021 reconova.com,All Rights
        Reserved.闽ICP备12019035号-1闽ICP备12019035号-2闽ICP备12019035号-3
      </div>
    </div>
    <LoginBlock style="position: absolute; top: 100px; right: 50px;"></LoginBlock>
  </div>
</template>

<script>
import LoginBlock from "./LoginBlock.vue";
export default {
  name: "LoginWrapper",
  components: {
    LoginBlock,
  },
  data() {
    return {
      list: [
        {
          title: "房东（经营者）",
          image: require("@/assets/img/item1.png"),
          color: "#BA1137",
          content: `借助智能科技手段，满足“实人实数实状态”上报要求，实现合规经营；
 配置智能终端，实现无人值守，释放人力，节省成本；
 PMS工具，提升运营服务能力；`,
        },
        {
          title: "租客",
          image: require("@/assets/img/item2.png"),
          color: "#FCBF0C",
          content: `线上线上身份核验，实名登记、实人核验；
 “手机智能开门”、“在线办理”等服务为租客的通行居住带来更多便利；
 全新的管理模式为网约房租赁市场建立起一层牢固的安全防护体系，保障了租客的入住安全；`,
        },
        {
          title: "公安",
          image: require("@/assets/img/item3.png"),
          color: "#115FBA",
          content: `科技创新，简化流程，警民合作，助推行业发展；
 一标三实标准，优化基础数据，摸清房源、经营者、人员数据，实时掌握辖区流动人员动态；
 发挥大数据分析研判能力，做到事前事中异常预警；`,
        },
      ],
      featureList: [
        {
          title: "信息报备",
          detail: "PC+微信小程序双通道报备单位、房源、入住人等基础信息",
        },
        {
          title: "身份核验",
          detail: "帮助经营者快速对租客进行实人核验，降低经营风险",
        },
        {
          title: "智能入住",
          detail: "无需前台，手机端实现下单、认证、入住、退房、换房等操作",
        },
        {
          title: "经营管理",
          detail: "融合PMS业务，助力商家经营管理，降本提效",
        },
        {
          title: "合法合规",
          detail: "落实治安管理条例，直联公安平台自动推送四实信息",
        },
        {
          title: "智能感知",
          detail: "配套智能门锁、门铃等感知设备",
        },
      ],
    };
  },
};
</script>

<style lang='less' scoped>
.login-wrapper {
  width: 100%;
  height: 100vh;
  overflow: auto;
  position: relative;
  .background {
    .header {
      padding: 16px 32px;
      img {
        width: 135px;
        height: 48px;
      }
    }
    .banner {
      img {
        width: 100%;
      }
    }
    .body {
      .title {
        position: relative;
        font-size: 36px;
        font-weight: bold;
        margin: 32px;
        z-index: 1;
        &::after {
          @padding: 50px;
          content: "";
          background-color: #fcbf0c;
          height: 20px;
          width: calc(100% + 2 * @padding);
          border-radius: 28px;
          position: absolute;
          bottom: 0px;
          left: -@padding;
          z-index: -1;
        }
      }
      .short-description {
        height: 161px;
        background: #fcbf0c;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 20px;
      }
      .service-target {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 32px;
        .content {
          padding: 0 200px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .top {
            margin-bottom: 32px;
          }
          .bottom {
            display: flex;
            justify-content: space-between;
            .item {
              flex: 1;
              margin-right: 16px;
              &:last-child {
                margin-right: 0;
              }
              .image {
                position: relative;
                border-radius: 10px;
                overflow: hidden;
                img {
                  width: 100%;
                }
                div {
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 100%;
                  text-align: center;
                  color: white;
                  padding: 24px 0;
                  font-size: 24px;
                  font-weight: bold;
                  color: #ffffff;
                }
              }
              .description {
                margin-top: 16px;
                white-space: pre-wrap;
              }
            }
          }
        }
      }
      .main-feature {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #f4f4f5;
        .content {
          display: flex;
          flex-wrap: wrap;
          padding: 0 100px;
          .item {
            display: flex;
            width: 50%;
            margin-bottom: 30px;
            .circle {
              flex-shrink: 0;
              width: 48px;
              height: 48px;
              background-color: #fcbf0c;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 16px;
            }
            .info {
              .info-title {
                font-size: 24px;
                color: #3d3d3d;
              }
              .info-detail {
                font-size: 18px;
              }
            }
          }
        }
      }
    }
    .footer {
      background: #091136;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      padding: 64px 0 16px;
    }
  }
}
</style>
